import cloneDeep from 'lodash.clonedeep';

const INIT_OPTIONS = {
    decimals: 2,
    gaugeWidthScale: 0.8,
    pointer: false,
    valueFontFamily:"Work Sans",
    gaugeColor: ['#EAEAEA'],
    levelColors: ['#A05AA0'],
    relativeGaugeSize:true,
    maxLabelMinFontSize:6,
    minLabelMinFontSize:6,
    pointerOptions: {
        toplength: 10,
        bottomlength: 10,
        bottomwidth: 2
    },
    counter: true,
    textRenderer: function(value) {
        return '€' + value + 'M'
    }
}

class ABChartGaugeCore {
    target;
    targetObj;
    options;
    plugin;

    constructor(target, options) {
        this.target = target;
        this.targetObj = this.getTarget(target);
        this.options = this.getOptions(options);
    }

    getOptions(options) {
        const newOpt =  Object.assign({}, cloneDeep(INIT_OPTIONS), options);
        return newOpt;
    }
    getTarget(target) {
        return document.querySelector(target);
    }

    render() {
        if (!this.plugin) {
            this.plugin = new JustGage({
                id: this.target,
                defaults: this.options
            });
        }
    }

    destroy() {
        this.plugin.destroy();
        this.plugin = null;
    }

    refresh(options) {
        this.options = Object.assign({}, this.options, options);
        /*this.plugin.refresh(options.value, options.max, options.min, options.label);
        this.plugin.update('minTxt',options.minTxt);
        this.plugin.update('maxTxt',options.maxTxt);*/
        this.destroy();
        this.render();
    }
}

class ABChartGauge {
    core;
    constructor(target, options) {
        this.core = new ABChartGaugeCore(target, options);
    }

    render() {
        this.core.render();
    }

    refresh(options) {
        this.core.refresh(options);
    }
}

window.ABChartGauge = ABChartGauge;

export default ABChartGauge;